import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface WeeklyData {
  week: string;
  predicted: number;
  actual?: number;
}

interface WeeklyBreakdownChartProps {
  data: WeeklyData[];
  loading?: boolean;
}

const WeeklyBreakdownChart: React.FC<WeeklyBreakdownChartProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="h-48 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-slate-800/95 border border-slate-600/50 rounded-xl p-4 shadow-xl backdrop-blur-sm">
          <p className="text-slate-200 font-semibold mb-2">{label}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} className="text-violet-400 font-bold">
              {entry.name}: {Math.round(entry.value)} kWh
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-48 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="week" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar 
            dataKey="predicted" 
            fill="#6366f1" 
            radius={[2, 2, 0, 0]}
            name="Predicted"
            animationDuration={300}
          />
          <Bar 
            dataKey="actual" 
            fill="#10b981" 
            radius={[2, 2, 0, 0]}
            name="Actual"
            animationDuration={300}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeeklyBreakdownChart;